﻿
cb.define([], function (common) {
	var AA_aa_adjacentstoregroup_VM_Extend = {
		doAction: function (name, viewmodel) {
			if (this[name])
				this[name](viewmodel);
		},
		init: function (viewmodel) {
			var self = this;
			var mode = viewmodel.getParams().mode;
			//卡片是浏览态,隐藏部分按钮
			if (mode === "browse") {
				self.setReadalbe(viewmodel);
			} else if (mode === "edit") {
				viewmodel.get("btnSaveAndAdd").setVisible(false);
			}

			var storeModel = viewmodel.get("AdjacentStores");
			var warehouseModel = viewmodel.get("AdjacentWarehouses");
			var orgModel = viewmodel.get("AdjacentOrgs");

			//保存前判断是否已经选择门店
			viewmodel.on('beforeSave', function (args) {
				debugger
				var rows = storeModel.getRows();
				if (rows.length == 0) {
					cb.utils.alert("周边门店不能为空！");
					return false;
				}
				for (var i = 0; i < rows.length; i++) {
					var store = rows[i]["store"];
					if (typeof (store) == "undefined") {
						cb.utils.alert("周边门店不能为空！");
						return false;
					}
				}

				var storestr = "";
				for (var i = 0; i < rows.length; i++) {
					if (storestr.indexOf(rows[i]["store"]) > -1) {
						cb.utils.alert("周边门店不能重复！");
						return false;
					}
					storestr = storestr + rows[i]["store"] + ",";
				}


				var orgstr = "";
				var rowOrgs = orgModel.getRows();
				for (var i = 0; i < rowOrgs.length; i++) {
					if (orgstr.indexOf(rowOrgs[i]["org"]) > -1) {
						cb.utils.alert("组织不能重复！");
						return false;
					}
					orgstr = orgstr + rowOrgs[i]["org"] + ",";
				}

			});

			viewmodel.on('beforeDelete', function (args) {
				return self.checkorg(viewmodel,args);
		   });	

		   if(orgModel) {
			orgModel.on('beforeBrowse', function (data) {
				if (data) {
				}
			});
			
			orgModel.on('beforeDeleteRows', function (data) {
				debugger;

				var rows = warehouseModel.getRows();
				var orgstr = "";
				rows.forEach(function (item, index) {
					if (item.org === undefined) return;
					orgstr = orgstr + item.org + ",";
				})

				if (data == undefined || data.length == 0) {
				}
				else {
					var length = data.length;
					for (var i = 0; i < length; i++) {
						var index=orgstr.indexOf(data[i]["org"]);
						if (index > -1) {
							cb.utils.alert("已经关联业务仓库，不可删除！");
							return false;
						}
					}
				}

			});

				orgModel.on('beforeCellValueChange', function (data) {
					switch (data.cellName) {
						case "org_name":
							{
								if (data.value.id != "")//检查是否存在重复的数据
								{
									var length = this.getRows().length;
									for (var i = 0; i < length; i++) {
										if (i != data.rowIndex) {
											if (data.value.id == this.getCellValue(i, 'org')) {
												cb.utils.alert("已经分配该组织，请检查后重试！");
												return false;
											}
										}
									}
								}
								break;
							}

					}
				});

		}
		
			if (warehouseModel) {
				warehouseModel.on('beforeBrowse', function (data) {
					debugger;
					if (data) {
						switch (data.cellName) {
							case "warehouse_name":
								var rows = orgModel.getRows();
								var orgids = [];
								rows.forEach(function (item, index) {
									if (item.org_name === undefined) return;
									orgids.push(item.org);
								})
								if (rows.length == 0) {
									cb.utils.alert("请先选择组织！");
									return false;
								}

								//参照面板中只显示非门店仓和启用状态为启用的仓库
								//1.过滤非门店仓
								var condition = { "isExtend": true, simpleVOs: [] };
								condition.simpleVOs.push({
									field: 'wStore',
									op: 'eq',
									value1: false
								});
								//2.启用状态为启用
								condition.simpleVOs.push({
									field: 'iUsed',
									op: 'eq',
									value1: 'enable'
								});


								if (orgids) {
									condition.simpleVOs.push({
										field: 'org',
										op: 'in',
										value1: orgids
									});
								}
								data.context.setFilter(condition);
								break;
						}
					}

				});

				//默认仓库设置
				warehouseModel.on('afterCellValueChange', function (data) {
					switch (data.cellName) {
						case "isDefault":
							{
								if (data.value.value == 1) //当默认选择是的情况下，处理所有其他行为否，并且设置主表默认仓库id
								{
									if (this.getCellValue(data.rowIndex, 'warehouse')) //判断当前行仓库是否没有填写
									{
										viewmodel.get("warehouse").setValue(this.getCellValue(data.rowIndex, 'warehouse'));
										var length = this.getRows().length;
										for (var i = 0; i < length; i++) {
											if (i != data.rowIndex) {
												this.setCellValue(i, 'isDefault', 0);
											}
										}
									}
								}
								break;
							}
					}

				});
			}

			if (storeModel) {
				storeModel.on('beforeBrowse', function (data) {
					//	debugger;
					if (data) {
						switch (data.cellName) {
							case "store_name":
								//参照面板中只显示启用状态为启用的门店
								var condition = { "isExtend": true, simpleVOs: [] };
								//启用状态为启用
								condition.simpleVOs.push({
									field: 'stop',
									op: 'eq',
									value1: 0
								});
								data.context.setFilter(condition);

								var rows = storeModel.getRows();
								var storeids = [];
								rows.forEach(function (item, index) {
									if (data.rowIndex === index) return;
									if (item.store_name === undefined) return;
									storeids.push(item.store);
								})
								if (storeids) {
									condition.simpleVOs.push({
										field: 'id',
										op: 'nin',
										value1: storeids
									});
								}
								data.context.setFilter(condition);
								break;
						}
					}

				});
			}

		},


		checkorg:function(viewmodel,args){
			debugger;
			
							var rows = warehouseModel.getRows();
							var orgids = [];
							rows.forEach(function (item, index) {
								if (item.org === undefined) return;
								orgids.push(item.org);
							})
			
							var selectedRows = viewmodel.getGridModel().getSelectedRows();
							if (selectedRows == undefined || selectedRows.length == 0) {
							}
							else {
								var length = selectedRows.length;
								for (var i = 0; i < length; i++) {
			
									if (orgids.indexOf(selectedRows[i]["id"]) == -1) {
										cb.utils.alert("已经关联业务仓库，不可删除！");
										return false;
									}
								}
							}
							return true;
	      },

		//浏览态
		setReadalbe: function (viewmodel) {
			// viewmodel.get("btnDeleteContact").setVisible(false);
			// viewmodel.get("btnDeleteRow").setVisible(false);
			// viewmodel.get("btnSaveAndAdd").setVisible(false);
			// viewmodel.get("btnSave").setVisible(false);
			// viewmodel.get("btnAbandon").setVisible(false);
		}
	}
	try {
		module.exports = AA_aa_adjacentstoregroup_VM_Extend;
	} catch (error) {

	}
	return AA_aa_adjacentstoregroup_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_adjacentstoregroup_VM.Extend.js